// TODO refactor to obejct or enum

export const DASHBOARD = '/v2/dashboard';
export const V2_SETTINGS = '/v2/settings';
export const V2_CONFERENCE = `${DASHBOARD}/conference`;

// SSO & Login
export const LOGIN = '/v2/login';
export const LOGOUT = '/v2/logout';
export const SSO_INTEGRATION = '/v2/sso-enabled';

// Azure Integration
export const V2_AZURE_INTEGRATION = `${V2_SETTINGS}/azure`;

// Audio & IVR
export const AUDIO_LIBRARY_ADMIN = `${V2_SETTINGS}/audio`;
export const V2_IVR_MENUS = `${V2_SETTINGS}/ivr`;

export const V2_PHRASES = `${AUDIO_LIBRARY_ADMIN}/phrases`;

export const V2_VOICEMAIL = `${V2_SETTINGS}/voicemail`;
export const V2_VOICEMAIL_ACTIVE = `${V2_VOICEMAIL}/active`;
export const V2_VOICEMAIL_GREETING = `${V2_SETTINGS}/voicemail/greeting`;
export const V2_VOICEMAIL_MESSAGE = `${V2_SETTINGS}/voicemail/message`;

// Call Center
// todo to be changed to call_center when everything is migrated
export const CALL_CENTER_QUEUES_V2 = `${DASHBOARD}/queues`;
export const CALL_CENTER_QUEUE_ACTIVE_NAME = `${CALL_CENTER_QUEUES_V2}/active-name`;
export const CALL_CENTER_QUEUE_KPIS = `${CALL_CENTER_QUEUES_V2}/kpis`;
export const CALL_CENTER_AGENTS_V2 = `${DASHBOARD}/agents`;
export const V2_CALL_CENTER_QUEUES = `${V2_SETTINGS}/call-center/queues`;
export const V2_CALL_CENTER_QUEUES_PREVIEW = `${V2_CALL_CENTER_QUEUES}/preview`;
export const V2_CALL_CENTER = `${V2_SETTINGS}/call-center`;
export const V2_CALL_CENTER_QUEUES_AGENTS = `${V2_SETTINGS}/call-center/queues/agents`;
export const V2_CALL_CENTER_AGENTS = `${V2_CALL_CENTER}/agents`;
export const V2_CALL_CENTER_ANALYTICS = '/v2/dashboard/callcenter-analytics';
export const V2_CALL_CENTER_RECORDING = `${CALL_CENTER_AGENTS_V2}/audio-recording`;
export const V2_CALL_HISTORY = `${DASHBOARD}/call-history`;
export const V2_CALL_HISTORY_BY_NUMBER = `${V2_CALL_HISTORY}/by-number`;
export const V2_CALL_HISTORY_BY_QUEUE = `${V2_CALL_HISTORY}/by-queue`;
export const V2_CALL_HISTORY_SUPERVISOR = `${V2_CALL_HISTORY}/supervisor`;

// Admin Entities
export const V2_ADMIN_RING_GROUPS = `${V2_SETTINGS}/ring-groups`;
export const V2_USER_RING_GROUPS = `${V2_SETTINGS}/user-ring-groups`;
export const V2_ADMIN_PICKUP_GROUPS = `${V2_SETTINGS}/pickup-groups`;
export const V2_ADMIN_DEVICES = `${V2_SETTINGS}/devices`;
export const V2_ADMIN_DEVICES_XLSX_TEMPLATE = `${V2_ADMIN_DEVICES}/get-xlsx-template`;
export const V2_ADMIN_DEVICES_XLSX_IMPORT = `${V2_ADMIN_DEVICES}/import-xlsx`;
export const V2_ADMIN_DEVICE_PROFILES = `${V2_ADMIN_DEVICES}/profiles`;
export const V2_ADMIN_DEVICE_TEMPLATES = `${V2_ADMIN_DEVICES}/templates`;
export const V2_ADMIN_DEVICE_VENDOR_FUNCTIONS = `${V2_ADMIN_DEVICES}/vendor/functions`;
export const V2_ADMIN_ZERO_TOUCH_SYNC = `${V2_ADMIN_DEVICES}/zero-touch/sync`;

// Contacts
export const V2_CONTACTS = '/v2/contacts';
export const PERSONAL_CONTACTS = `${V2_CONTACTS}/personal`;
export const GLOBAL_CONTACTS = `${V2_CONTACTS}/global`;
export const CONTACTS_XLSX_TEMPLATE = `${V2_CONTACTS}/get-xlsx-template`;
export const CONTACTS_XLSX_IMPORT_PERSONAL = `${V2_CONTACTS}/import-personal-xlsx`;
export const CONTACTS_XLSX_IMPORT_GLOBAL = `${V2_CONTACTS}/import-global-xlsx`;
export const V2_CONTACTS_BULK_DELETE_PERSONAL = `${V2_CONTACTS}/bulk-delete/personal`;
export const V2_CONTACTS_BULK_DELETE_GLOBAL = `${V2_CONTACTS}/bulk-delete/global`;
export const V2_CONTACT_AVATAR = `${V2_CONTACTS}/attachments`;
export const V2_AZURE_CONTACTS_SYNC = `${V2_CONTACTS}/azure/sync`;
export const V2_CONTACTS_SPEED_DIAL_VALIDATOR = `${V2_CONTACTS}/speed-dial`;
export const PHONEBOOK_GROUPS = '/v2/phonebook-groups';
export const PERSONAL_PHONEBOOK_GROUPS = `${PHONEBOOK_GROUPS}/personal`;
export const GLOBAL_PHONEBOOK_GROUPS = `${PHONEBOOK_GROUPS}/global`;
export const V2_FAVOURITES_CONTACTS = `${V2_CONTACTS}/favorites`;

// User & Domain Settings
export const V2_USERS = '/v2/users';
export const V2_USERS_ME = `${V2_USERS}/me`;
export const V2_USERS_STATUS = `${V2_USERS}/status`;
export const V2_AGENTS = `${V2_USERS}/agents`;
export const V2_ADMIN_USERS = `${V2_USERS}/overview`;
export const V2_USERS_AVAILABILITY = `${V2_USERS}/availability`;
export const V2_LICENSES = 'v2/licenses';
export const V2_LICENSE_TYPES = `${V2_LICENSES}/types`;
export const V2_ADMIN_USERS_TEMPLATE = `${V2_USERS}/import/template`;
export const V2_ADMIN_USERS_EXAMPLES = `${V2_USERS}/import/examples`;
export const V2_ADMIN_USERS_XLSX_IMPORT = `${V2_USERS}/import`;
export const V2_DOMAIN_SETTINGS = `${V2_SETTINGS}/domain`;
export const V2_DOMAIN_OPTIONS = `${V2_DOMAIN_SETTINGS}/options`;
export const V2_USER_SETTINGS = `${V2_SETTINGS}/user`;
export const V2_EXTENSIONS_SETTINGS = `${V2_USER_SETTINGS}/extension-settings`;
export const V2_SECRETARY_STATUS = `${V2_USER_SETTINGS}/is-secretary`;
export const V2_CALL_FORWARD_EXTENSION_SETTINGS = `${V2_USER_SETTINGS}/extension-forward`;
export const V2_FOLLOW_ME_EXTENSION_SETTINGS = `${V2_USER_SETTINGS}/extension-follow-me`;
export const BLACKLIST = `/v2/settings/blacklist`;
export const V2_USER_VALIDATOR = `${V2_USERS}/validator`;

// External Numbers
export const V2_EXTERNAL_NUMBERS = `${V2_SETTINGS}/external-numbers`;
export const V2_EXTERNAL_NUMBERS_INBOUND_OPTIONS = `${V2_EXTERNAL_NUMBERS}/inbound/options`;
export const V2_EXTERNAL_NUMBERS_OUTBOUND_OPTIONS = `${V2_EXTERNAL_NUMBERS}/outbound/options`;
export const V2_EXTERNAL_NUMBERS_REGEX = `${V2_EXTERNAL_NUMBERS}/regex`;
export const V2_EXTERNAL_NUMBERS_INBOUND = `${V2_EXTERNAL_NUMBERS}/inbound`;
export const V2_EXTERNAL_NUMBERS_MY_OUTBOUND_OPTIONS = `${V2_EXTERNAL_NUMBERS_OUTBOUND_OPTIONS}/me`;
export const V2_EXTERNAL_NUMBERS_SELECTED_OUTBOUND_NUMBER = `${V2_EXTERNAL_NUMBERS}/outbound/current`;

// Time and Conditions
export const TIME_CONDITIONS = `${V2_SETTINGS}/time-conditions`;

// Password
export const PASSWORD = '/v2/password';
export const PASSWORD_RESET = `${PASSWORD}/reset`;
export const PASSWORD_RESET_REQUEST = `${PASSWORD}/reset-request`;

// Call-Related Endpoints
export const V2_WARM_TRANSFER = `${V2_USERS}/transfer/warm`;

export const V2_BANNER = `${V2_USER_SETTINGS}/banner`;
